import { Label, List, ListInlineItem } from "reactstrap";
import { Href } from "../../../../Constant";
import { Link } from "react-router-dom";
import { COMMON_FOOTER } from "../../../../Data/Bonus Ui/Tour";

export const CommonTourFooter = () => {
  return (
    <div className="like-comment mt-4">
      <List type="inline">
        {COMMON_FOOTER.map(({ className, icon, text }, index) => (
          <ListInlineItem className={className} key={index}>
            <Label className="m-0" check><Link to={Href}><i className={`fa fa-${icon}`}></i></Link>{text}</Label>
          </ListInlineItem>
        ))}
      </List>
    </div>
  );
};
